import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Category } from '../../../../interfaces/categoryInterface';
import { GenericStream, GenericStreamStatus, GenericStreamType, VideoObject } from '../../../../lib/interfaces/generic-streams';
import { AppdataService, Llm } from '../../../../service/appdata.service';
import { GenericStreamsService } from '../../../../service/generic-streams.service';

@Component({
    selector: 'app-add-generic-stream',
    standalone: false,
    templateUrl: './add-generic-stream.component.html',
    styleUrl: './add-generic-stream.component.scss'
})
export class AddGenericStreamComponent implements AfterViewInit, OnInit {
    configDialog = inject(MatDialogRef<AddGenericStreamComponent>);
    streamData = inject(MAT_DIALOG_DATA);
    fb = inject(FormBuilder);
    dataService = inject(AppdataService);
    genericService = inject(GenericStreamsService);
    genericStreamType = GenericStreamType;
    cd = inject(ChangeDetectorRef);


    promotionAreaVideos: VideoObject[] = [];
    promotionImageForDisplay: string = '';
    llms: Llm[] = [];
    categoryList: string[] = [];
    formGroup = this.fb.group({
        id: [null],
        name: [, Validators.required],
        description: [],
        status: ['', Validators.required],
        type: ['', Validators.required],
        connectedStreamIds: [[]],
        llmId: ['', Validators.required],
        categoryId: [this.categoryList],
        streamGoal: ["", Validators.required],
        globalStream: [true],
        promotionStatus: [false],
        promotionAreaVideos: []
    });


    streamTypes = [
        { id: GenericStreamType.FREE, label: 'Free' },
        { id: GenericStreamType.PROFESSIONAL, label: 'Professional' },
    ];
    streamStatus = [
        { id: GenericStreamStatus.INACTIVE, label: 'Inactive' },
        { id: GenericStreamStatus.EXPERIMENTAL, label: 'Experimental' },
        { id: GenericStreamStatus.ACTIVE, label: 'Active' },
        { id: GenericStreamStatus.PENDING, label: 'Pending' }
    ]
    catgeories: Category[] = []
    editMode: boolean = false;

    loadVideos(videos: any[]): void {
        console.log('loadVideos called with', videos);
        videos.forEach((v: VideoObject) => {
            this.promotionImageForDisplay = v?.thumbnail ?? '';
            this.addVideo(v?.url ?? '', v?.title ?? '', v?.description ?? '');
        });
        this.cd.detectChanges(); // Force update after all videos are added
    }

    convertImgToBase64(event: Event) {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (!file) return;
        const reader = new FileReader();
        this.promotionImageForDisplay = '';
        return new Promise((resolve, reject) => {
            reader.onload = () => {
                this.promotionImageForDisplay = reader.result as string;
                resolve(this.promotionImageForDisplay);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    addVideo(url: string = '',  title: string = '', description: string = ''): void {
        console.log('addVideo called with:', { url, thumbnail: this.promotionImageForDisplay, title, description });
        const videoGroup = {
            url: url,
            thumbnail: this.promotionImageForDisplay,
            title: title,
            description: description
        };
        console.log('Before push, promotionAreaVideos length:', this.promotionAreaVideos.length);
        this.promotionAreaVideos.push(videoGroup);
        console.log('After push, promotionAreaVideos length:', this.promotionAreaVideos.length);
        console.log('Full videos array:', JSON.parse(JSON.stringify(this.promotionAreaVideos)));
        // Force change detection
        this.cd.detectChanges();
    }

    removeVideo(index: number): void {
        this.promotionAreaVideos.splice(index, 1);
        this.cd.detectChanges();
    }

    ngAfterViewInit(): void {
        this.dataService.llms.subscribe((llms) => {
            if (llms.length != 0) {
                this.llms = llms
                this.cd.detectChanges();

            }
        });
        this.dataService.categories.subscribe((categories) => {
            if (categories.length !== 0) {
                this.catgeories = categories
                this.cd.detectChanges();
            }
        });

    }
    ngOnInit(): void {
        // console.log(this.streamData)
        this.formGroup.valueChanges.subscribe(status => {
            // console.log('Status changed:', status);
            this.refreshCategoryIdValidators();
            this.cd.detectChanges();
        });

        if (this.streamData?.name) {
            console.log('Edit Stream Data:', this.streamData);
            console.log('Promotion Area:', this.streamData.promotionArea);
            this.editMode = true;
            this.formGroup.patchValue({ name: this.streamData.name });
            this.formGroup.patchValue({ description: this.streamData.description });
            this.categoryList = this.streamData.categoryId;
            this.formGroup.patchValue({
                llmId: this.streamData.llmId,
                type: this.streamData.type
            });

            this.formGroup.patchValue({ status: this.streamData.status });
            this.formGroup.patchValue({ streamGoal: this.streamData.streamGoal });
            this.formGroup.patchValue({ globalStream: !!this.streamData.globalStream });

            const existingPromo = this.streamData?.promotionArea;
            console.log('existingPromo:', existingPromo);
            console.log('existingPromo.status:', existingPromo?.status, 'typeof:', typeof existingPromo?.status);
            if (existingPromo) {
                console.log('existingPromo.status:', existingPromo.status, 'typeof:', typeof existingPromo.status);
                console.log('!!existingPromo.status:', !!existingPromo.status);
                const promoStatus = !!existingPromo.status || existingPromo.status === 'true' || existingPromo.status === true;
                console.log('promoStatus:', promoStatus);
                console.log('Setting promotionStatus to:', promoStatus);
                this.formGroup.patchValue({ promotionStatus: promoStatus });
                console.log('promotionStatus after patch:', this.formGroup.get('promotionStatus')?.value);
                this.cd.detectChanges(); // Force update after patchValue
            }

            if (existingPromo && Array.isArray(existingPromo.videos)) {
                console.log('Adding', existingPromo.videos.length, 'videos');
                existingPromo.videos.forEach((v: any, i: number) => {
                    console.log('Video', i, 'from DB:', v);
                });
                this.loadVideos(existingPromo.videos);
            }
            // Force change detection after all videos are added
            this.cd.detectChanges();
        }
    }


    // async deleteCategory(id: string) {
    //     this.categoryList = this.categoryList.filter(category => category !== id);
    //     this.refreshCategoryIdValidators();
    // }
    addCategory(stack: string[]) {
        this.categoryList = stack
        // console.log("CategoryList", this.categoryList, this.formGroup.value)
        this.formGroup.patchValue({ categoryId: this.categoryList });
        this.refreshCategoryIdValidators();
    }
    close() {
        this.configDialog.close();
    }


    async saveGenStream() {
        if (!this.formGroup || !this.formGroup.value || this.formGroup.invalid) return;
        console.log('formGroup.value:', this.formGroup.value);

        let newStream: GenericStream = {
            // Data from Form
            id: null,
            name: this.formGroup?.value?.name || '',
            description: this.formGroup.get('description')?.value || '',
            categoryId: this.categoryList,
            status: this.formGroup.get('status')?.value as GenericStreamStatus,
            type: this.formGroup.get('type')?.value as GenericStreamType,
            llmId: this.formGroup.get('llmId')?.value || '',
            globalStream: this.formGroup.get('globalStream')?.value || false,
            // Data From existing stream
            connectedStreamIds: this.streamData?.connectedStreams || [],
            credits: this.streamData?.credits || 0,
            duration: this.streamData?.duration || 0,
            steps: this.streamData?.steps || [],
            promotionArea: {
                videos: JSON.parse(JSON.stringify(this.promotionAreaVideos)),
                status: this.formGroup.get('promotionStatus')?.value || false,
                imgStatus: false,
                imgUrl: null,
                headline: null,
                description: null,
                targetUrl: null,
            },
            streamGoal: this.formGroup.get('streamGoal')?.value || "",
            streamResults: this.streamData?.streamResults || [],
        }

        // console.log(newStream);
        let result = this.streamData?.id || true;
        if (this.editMode === false) {
            result = await this.genericService.addGenericStream(newStream);
            if (result !== false) {
                this.configDialog.close(result);
                return;
            }
        } else {
            this.configDialog.close({
                name: this.formGroup.value.name,
                description: this.formGroup.value.description,
                categoryId: this.categoryList,
                status: this.formGroup.value.status,
                type: this.formGroup.value.type,
                llmId: this.formGroup.value.llmId,
                streamGoal: this.formGroup.value.streamGoal,
                id: this.streamData.id,
                globalStream: this.formGroup.value.globalStream,
                promotionArea: {
                    status: this.formGroup.get('promotionStatus')?.value || false,
                    imgStatus: false,
                    imgUrl: null,
                    headline: null,
                    description: null,
                    targetUrl: null,
                    videos: JSON.parse(JSON.stringify(this.promotionAreaVideos)),
                }

            });

        }

    }
    private refreshCategoryIdValidators(): void {
        const ctrl = this.formGroup.get('categoryId');
        if (this.categoryList.length === 0) {
            ctrl?.setErrors({ notEnoughCategories: true });
        } else {
            ctrl?.clearValidators();
        }
        ctrl?.updateValueAndValidity({ onlySelf: true });
    }
}
